<template>
  <div class="author-course">
    <div class="course-management">
      <div class="course-title">课程管理</div>
      <div class="line"></div>
      <el-button type="primary" class="course-operation" @click="newCourse"
        >+新建课程</el-button
      >
      <div class="course-list">
        <el-table
          :data="authorCourseList"
          :header-row-style="{ textAlign: 'center' }"
          @row-click="openDetails"
          @sort-change="sortChange"
          :row-class-name="tableRowClassNameParent"
          :default-sort="{ prop: 'createTime', order: 'descending' }"
        >
          <el-table-column
            fixed
            prop="coverImageUrl"
            label="课程封面"
            width="115"
          >
            <template slot-scope="scope">
              <img :src="scope.row.coverImageUrl" class="column-image" />
            </template>
          </el-table-column>
          <el-table-column fixed prop="title" label="产品名称" width="180">
          </el-table-column>
          <el-table-column fixed prop="typeName" label="类型" width="60">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            sortable
            width="110"
            fixed
          >
            <template slot-scope="scope">
              {{ dayjs(scope.row.createTime).format('YYYY-MM-DD') }}
            </template>
          </el-table-column>
          <el-table-column
            fixed
            prop="updateTime"
            label="更新时间"
            width="100"
            sortable
          >
            <template slot-scope="scope">
              {{ dayjs(scope.row.updateTime).format('YYYY-MM-DD') }}
            </template>
          </el-table-column>
          <el-table-column fixed prop="totalCourse" label="课程节数" width="76">
          </el-table-column>
          <el-table-column fixed prop="commentCount" label="评论数" width="65">
            <template slot-scope="scope">
              <el-button
                class="tb-col-btn"
                type="text"
                size="small"
                @click.stop="relateComment(scope.row.id)"
              >
                {{ scope.row.commentCount }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column fixed prop="id" label="操作">
            <template slot-scope="scope">
              <el-button
                @click.stop="relateVideo(scope.row.id)"
                type="text"
                size="small"
              >
                管理关联视频
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-show="!pageEnd" class="more" @click="getMore">点击查看更多</div>
      </div>
    </div>
    <div class="contact-panel">
      <author-contact-us></author-contact-us>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="750px">
      <div class="course-detail">
        <div class="course-detail-title">
          <img
            :src="courseDetailList.courseSummary.coverImageUrl"
            class="course-detail-image"
          />
          <div class="course-detail-titles">
            <div class="title">{{ courseDetailList.courseSummary.title }}</div>
            <el-tag class="total"
              >共{{ courseDetailList.courseSummary.totalCourse }}节</el-tag
            >
            <div class="description">
              {{ courseDetailList.courseSummary.description }}
            </div>
          </div>
        </div>
        <div class="line"></div>
        <ul class="course-detail-list">
          <el-table
            :data="courseDetailList.detailList"
            style="width: 100%"
            :row-class-name="tableRowClassName"
          >
            <el-table-column prop="index" width="150">
              <template slot-scope="scope">
                第{{ scope.row.index }}节
              </template>
            </el-table-column>
            <el-table-column prop="title" width="350"></el-table-column>
            <el-table-column prop="duration" width="150">
              <template slot-scope="scope">
                <img
                  src="~@/assets/images/authorcourse/duration.png"
                  class="course-duration"
                />
                {{ toHHMMSS(scope.row.duration) }}
              </template>
            </el-table-column>
          </el-table>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCourseSections } from '@/api/course'
import { getAuthorCourseList } from '@/api/authorcourse'
import AuthorContactUs from '@/components/AuthorContactUs'
import dayjs from 'dayjs'

export default {
  name: 'AuthorCourse',
  components: { AuthorContactUs },
  data() {
    return {
      authorCourseList: [],
      courseDetailList: {
        courseSummary: {},
        detailList: []
      },
      viewState: '',
      dialogVisible: false,
      pageSize: 10,
      pageIndex: 0,
      total: 0,
      sortKey: 'createTime',
      order: '1',
      orderby: 'desc'
    }
  },
  created() {
    this.getAuthorCourseList()
  },
  computed: {
    pageEnd: function () {
      return this.pageSize * (this.pageIndex + 1) >= this.total
    }
  },
  methods: {
    dayjs,
    relateVideo(id) {
      this.$router.push({ path: '/excl-author/course/' + id })
    },
    relateComment(id) {
      this.$router.push({ path: '/excl-author/course/comment/' + id })
    },
    newCourse() {
      this.$router.push({ path: '/excl-author/course/new-course' })
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return 'even-row'
      }
    },
    tableRowClassNameParent({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return 'even-row cursor'
      }
      return 'cursor'
    },
    sortChange(info) {
      this.orderby =
        info.order != null
          ? info.order === 'descending'
            ? 'desc'
            : 'asc'
          : 'createTime'
      this.sortKey = info.prop
      this.pageIndex = 0
      this.getAuthorCourseList()
    },
    getMore() {
      this.pageIndex += 1
      this.getAuthorCourseList()
    },
    toHHMMSS(duration) {
      var secnum = parseInt(duration, 10) // don't forget the second param
      var hours = Math.floor(secnum / 3600)
      var minutes = Math.floor((secnum - hours * 3600) / 60)
      var seconds = secnum - hours * 3600 - minutes * 60

      if (hours < 10) {
        hours = '0' + hours
      }
      if (minutes < 10) {
        minutes = '0' + minutes
      }
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      return hours + ':' + minutes + ':' + seconds
    },
    openDetails(row) {
      this.getCourseSections(row.id)
      this.courseDetailList.courseSummary = row
      this.dialogVisible = true
    },
    async getCourseSections(id) {
      this.courseDetailList.detailList = await getCourseSections({
        courseSetId: id
      })
    },
    async getAuthorCourseList() {
      const data = await getAuthorCourseList({
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        sortKey: this.sortKey,
        orderby: this.orderby
      })
      if (data) {
        if (data.result.code === 0) {
          this.pageSize = data.detail.pageSize
          this.pageIndex = data.detail.pageIndex
          this.total = data.detail.total
          if (this.pageIndex === 0) {
            this.authorCourseList = data.detail.list
          } else {
            this.authorCourseList = this.authorCourseList.concat(
              data.detail.list
            )
          }
        }
      }
    }
  }
}
</script>
<style>
.even-row {
  background: #fafafa !important;
}
.cursor {
  cursor: pointer;
}

.el-table .cell {
  text-align: center;
}

table .el-button {
  width: auto;
}
</style>
<style lang="scss" scoped>
.line {
  display: block;
  max-width: 95%;
  margin: 0 auto;
  border: solid 1px lightgray;
  border-width: thin 0 0;
  transition: inherit;
}
.author-course {
  display: flex;
}
.course-management {
  min-width: 800px;
  min-height: 1100px;
  margin-right: 20px;
  background-color: #ffffff;
  border: solid 1px #ebebeb;
  border-radius: 5px;
  flex: auto;
}

.course-title {
  padding-left: 30px;
  padding-top: 20px;
  font-size: 16px;
  height: 40px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  color: #262626;
}

.course-operation {
  margin-top: 25px;
  margin-left: 30px;
}

.course-list {
  margin-top: 30px;
  padding: 0 30px;
}

.column-image {
  width: 80px;
  height: 60px;
  background-size: cover;
}

.more {
  width: 828px;
  height: 40px;
  margin: 30px auto;
  font-size: 14px;
  line-height: 40px;
  color: #858585;
  background-color: #fafafa;
  text-align: center;
  cursor: pointer;
}

.course-detail-image {
  width: 160px;
  height: 120px;
}

.course-detail {
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px;
  padding-bottom: 70px;
  display: flex;
  flex-direction: column;
}
.course-detail-title {
  display: flex;
}

.course-detail-titles {
  margin-left: 20px;
}

.title {
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 1px;
  color: #262626;
}
.total {
  font-size: 14px;
  margin-bottom: 5px;
  font-weight: normal;
  font-stretch: normal;
  color: #046bcc;
}
.description {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  color: #858585;
}
.course-duration {
  padding-top: 2px;
  width: 14px;
  height: 14px;
  margin-right: 2px;
}

.contact-panel {
  width: 314px;
  flex: none;
  border-radius: 5px;
  background-color: #ffffff;
}
.tb-col-btn {
  width: 100%;
}
</style>
